// Component to be shown on inactivity modal popup

import { ChangeDetectionStrategy, Component } from '@angular/core';

import { ButtonComponent } from '../../atoms/button/button.component';
import { MatDialogRef } from '@angular/material/dialog';
import { RenderLabelPipe } from '../../../pipes/render-label/render-label.pipe';

@Component({
  selector: 'app-inactivity',
  templateUrl: './inactivity.component.html',
  styleUrls: ['./inactivity.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonComponent, RenderLabelPipe],
})
export class InactivityComponent {
  shouldRedirect = false;
  constructor(public dialogRef: MatDialogRef<InactivityComponent>) {}

  /**
   * Closes the inactivity modal box
   * @param isLogout is logout button clicked
   */
  closeInactivityDialog(isLogout: boolean): void {
    this.dialogRef.close(isLogout);
  }
}
